import type { Player } from "../../../common/types.ts";
import { g } from "../../util/index.ts";
import {
	planRoster,
	planRosterAddition,
} from "../team/rosterComposition.baseball.ts";

// Under this age a player is still developing: trade valuations treat his playing time as protected
export const MIN_DISSATISFACTION_AGE = 21;

const ROLE_LABELS: Record<string, string> = {
	SP: "a rotation spot",
	RP: "a bullpen spot",
	DH: "the DH spot",
	UT: "a utility spot",
	ANY: "a depth spot",
};
const REAL_ROLE_WEIGHT = 0.2;

// The role he would take on his club's big-league roster right now, if any. Uses the same
// roster plan as the AI: position ratings, starters and backups, DH, rotation and bullpen.
export const bigClubRole = (
	p: Player,
	roster: Player[],
	baseline = planRoster(roster, g.get("maxRosterSize"), g.get("dh") !== "none"),
) => {
	const plan = planRosterAddition(roster, p, baseline);
	const slotIndex = plan.assignment.findIndex((i) => i === roster.length);
	const slot = slotIndex >= 0 ? plan.slots[slotIndex] : undefined;
	if (!slot || slot.weight < REAL_ROLE_WEIGHT) {
		return;
	}
	const starter = slot.weight >= 0.6;
	const label =
		ROLE_LABELS[slot.pos] ??
		`${starter ? "the starting" : "the backup"} ${slot.pos} job`;
	return { pos: slot.pos, starter, label };
};
